/**
 * DPA version constants — Launch-08 LGPD.
 *
 * Quando você revisar texto com jurídico:
 *   1. Bumpa DPA_CURRENT_VERSION (formato YYYY-MM-DD)
 *   2. Próximo admin de cada domínio vê banner "DPA atualizado — re-aceite necessário"
 *   3. Aceites antigos ficam no audit log (imutável)
 */
export const DPA_CURRENT_VERSION = '2026-06-08';

/** Texto do título exibido na UI. */
export const DPA_TITLE = 'Data Processing Agreement (DPA) — Seraik Insights';

/** Sub-processadores listados — atualiza quando trocar de infra. */
export const DPA_SUBPROCESSORS = [
  { name: 'Supabase Inc.',     purpose: 'Banco de dados + autenticação',   region: 'AWS us-east-1 (USA)' },
  { name: 'Vercel Inc.',       purpose: 'Hospedagem do site',              region: 'AWS us-east-1 (USA)' },
  { name: 'Google Cloud',      purpose: 'Cloud Run staging + GCS storage', region: 'southamerica-east1 (Brasil)' },
  { name: 'Anthropic PBC',     purpose: 'Modelo de linguagem (LLM)',       region: 'AWS us-east-1 (USA)' },
  { name: 'Resend (Plunky)',   purpose: 'Envio transacional de email',     region: 'AWS us-east-1 (USA)' },
  { name: 'OpenAI Inc.',       purpose: 'Modelo backup (opcional)',        region: 'AWS us-east-1 (USA)' },
];
